import type { RncValidationFeedback } from "./types";

export const addCommercialNameToBilletFeedback = (
  feedback: RncValidationFeedback,
  commercialName: string
): RncValidationFeedback => {
  const name = commercialName.trim();

  if (
    feedback.kind !== "existsInBillet" ||
    feedback.commercialName ||
    !name
  ) {
    return feedback;
  }

  return { ...feedback, commercialName: name };
};
